<template>
    <div class="column user-dashboard" :style="panelStyles">
        <theme-scene :theme="theme" />
        <profile-stats
            :db-info="dbInfo"
            :overlay-styles="overlayStyles"
            :accent="theme.colors.accent" />
    </div>
</template>

<script>
import themedPanel from '../../mixins/themedPanel.js'

import ProfileStats from './ProfileStats.vue'
import ThemeScene from './ThemeScene.vue'

/**
 * `/profile/:id/stats` — the panel that carries the theme; ProfileStats does
 * the rendering.
 *
 * Deliberately not merged into ProfileStats. The panel frame (the themed
 * background, the scene behind it) is the same on all three routes and
 * belongs to whatever the router puts here; the stats themselves are also
 * rendered elsewhere and shouldn't have to carry a scene to do it.
 *
 * No `tierClass` — the tier treatment on the cards is Overview's alone, and
 * the Stats page has always stayed plain.
 */
export default {
    name: 'ProfileStatsPanel',
    components: { ProfileStats, ThemeScene },
    mixins: [themedPanel],
    props: {
        dbInfo: { type: Object, required: true },
    },
}
</script>
